import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/frontend_w3era/src/components/CommonComponent/DownNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/frontend_w3era/src/components/CommonComponent/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/frontend_w3era/src/components/CommonComponent/navbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/frontend_w3era/src/components/Pages/FooterPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/frontend_w3era/src/components/Pages/seo-service-page.tsx");
